import FJImageExtenderData from '../../config/dataConfig/FJImageExtenderData';
import FJConfig from '../../config/FJConfig';
import FJS3Config from '../../config/FJS3Config';
import FJConstant from '../../constants/FJConstant';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import {
    setSliceBoardSize,
    setSliceCurRatioName,
    setSliceGenerateNumber,
    setSliceImageRect,
    setSliceUploadImageInfo,
} from '../slices/FJSliceImageExtender';
import { setSliceIsShowPresetImageBox } from '../slices/FJSliceTextToImage';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import FJFileHandleUtil from '../../util/FJFileHandleUtil';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import { MAX_COMPRESS_IMAGE_SIZE } from '../../config/dataConfig/FJGenerateData.js';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';

const MIN_IMAGE_SIZE = 50;

let f_startGenerateTime = null;

const FJActionImageExtender = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageInfo({}));
            // dispatch(setSliceGenerateNumber(1));
            // dispatch(setSliceCurRatioName('original'));
        };
    },
    uploadImageAction: function (file) {
        return async dispatch => {
            const isGIF = await FJUtil.isGIF(file);
            if (isGIF) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            } else {
                const data = await FJCompressedImageStore.compressImageByFile(file);
                if (data) {
                    if (data.height < MIN_IMAGE_SIZE || data.width < MIN_IMAGE_SIZE) {
                        FJMessageStore.addMessage(FJLocalStore._('image-extender-upload-image-size-min'), 'error');
                        return;
                    }
                    dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                    dispatch(setSliceUploadImageInfo({ ...data }));
                    dispatch(this._fitBoardSizeByCurRatioAction());
                } else {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                }
            }
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async dispatch => {
            const { size, name, id } = options;
            let data;
            if (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE) {
                data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name });
            } else {
                data = { name: name, src: url, width: size.width, height: size.height, id: id };
            }
            if (data) {
                if (data.height < MIN_IMAGE_SIZE || data.width < MIN_IMAGE_SIZE) {
                    FJMessageStore.addMessage(FJLocalStore._('image-extender-upload-image-size-min'), 'error');
                    return;
                }
                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                dispatch(setSliceUploadImageInfo(data));
                dispatch(this._fitBoardSizeByCurRatioAction());
            } else {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    /**
     * @desc 根据当前比例计算画布大小、图片大小
     * @returns
     */
    _fitBoardSizeByCurRatioAction: function () {
        return async (dispatch, getState) => {
            const { uploadImageInfo } = getState().imageExtender;

            const curBoardRatioName = getState().imageExtender.curRatioName;
            const imageRatio = uploadImageInfo.width / uploadImageInfo.height;

            const curBoardRatio =
                curBoardRatioName === 'original'
                    ? imageRatio
                    : FJImageExtenderData.RATIO_LIST.find(item => item.name === curBoardRatioName)?.value;

            let newImageRect = { width: uploadImageInfo.width, height: uploadImageInfo.height };
            // 原图的最长边
            const maxDistance = Math.max(uploadImageInfo.width, uploadImageInfo.height);

            const newBoardSize = {
                width: curBoardRatio >= 1 ? maxDistance : Math.floor(maxDistance * curBoardRatio),
                height: curBoardRatio >= 1 ? Math.floor(maxDistance / curBoardRatio) : maxDistance,
            };

            if (curBoardRatioName === 'original') {
                newBoardSize.width = uploadImageInfo.width;
                newBoardSize.height = uploadImageInfo.height;
            }

            if (newBoardSize.width > FJImageExtenderData.IMAGE_MAX_EXTENDER_DISTANCE) {
                newBoardSize.width = FJImageExtenderData.IMAGE_MAX_EXTENDER_DISTANCE;
                newBoardSize.height = Math.floor(newBoardSize.width / curBoardRatio);
            }

            if (imageRatio > 1) {
                newImageRect.width = newBoardSize.width * 0.7;
                newImageRect.height = newImageRect.width / imageRatio;
            } else {
                newImageRect.height = newBoardSize.height * 0.7;
                newImageRect.width = newImageRect.height * imageRatio;
            }

            if (newImageRect.width > newBoardSize.width) {
                newImageRect.width = newBoardSize.width;
                newImageRect.height = newImageRect.width / imageRatio;
            }

            if (newImageRect.height > newBoardSize.height) {
                newImageRect.height = newBoardSize.height;
                newImageRect.width = newImageRect.height * imageRatio;
            }

            dispatch(
                setSliceBoardSize({
                    width: Math.floor(newBoardSize.width),
                    height: Math.floor(newBoardSize.height),
                }),
            );
            dispatch(
                setSliceImageRect({
                    width: newImageRect.width,
                    height: newImageRect.height,
                    x: (newBoardSize.width - newImageRect.width) / 2,
                    y: (newBoardSize.height - newImageRect.height) / 2,
                }),
            );
        };
    },

    /**
     * @desc 设置当前比例
     * @param {{}} ratioData
     * @returns
     */
    setCurRatioNameAction: function (ratioData) {
        return async dispatch => {
            dispatch(setSliceCurRatioName(ratioData.name));
            dispatch(this._fitBoardSizeByCurRatioAction());
        };
    },

    setBoardSizeAction: function (boardSize) {
        return dispatch => {
            dispatch(setSliceBoardSize(boardSize));
        };
    },

    setImageRectAction: function (imageRect) {
        return dispatch => {
            const newImageRect = { ...imageRect };
            dispatch(setSliceImageRect(newImageRect));
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const { uploadImageInfo, boardSize, imageRect, generateNumber } = getState().imageExtender;
            const { width, height } = boardSize;
            const { creditNumber, freeNumCreation } = getState().common;
            const { x, y, width: imageWidth, height: imageHeight } = imageRect;
            const taskStatus = getState().common.taskStatus;
            const curBoardRatioName = getState().imageExtender.curRatioName;
            f_startGenerateTime = new Date().getTime();
            let isFree = false;

            if (FJUtil.isGeneratingStatus(taskStatus)) return;
            if (!uploadImageInfo || !uploadImageInfo.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }

            const __errorCallback = failTaskCount => {
                if (!failTaskCount) {
                    dispatch(setSliceCreationListAction([]));
                } else {
                    const creationList = [...getState().common.creationList];
                    const allTaskListLength = creationList.length;

                    for (let i = allTaskListLength - failTaskCount; i < allTaskListLength; i++) {
                        creationList[i].isLoading = false;
                        creationList[i].isReload = true;
                    }
                    dispatch(setSliceCreationListAction(creationList));
                }

                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            };

            const __judgeCanGenerate = async () => {
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(
                            FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                            'error',
                        );
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }
                const useCredit = 2 * generateNumber;

                //4.额度判断
                const canFreeCreate = freeNumCreation > 0;
                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            FJUtil.eaLog('image extender generate click', {
                number: generateNumber,
                ratio: curBoardRatioName,
            });

            // 修改状态生成占位符
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: generateNumber,
                width: width,
                height: height,
                type: FJConstant.CREATIONS,
            });

            dispatch(FJActionCommon.setHeaderTabIndexAction(1));
            dispatch(setSliceIsShowPresetImageBox(false));
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            const isCanGenerate = await __judgeCanGenerate();

            if (!isCanGenerate) {
                __errorCallback();
                return;
            }
            // 1. 压缩图片
            const imageBlob = await FJCompressedImageStore.simpleCompressImage(
                uploadImageInfo.src,
                imageWidth,
                imageHeight,
            );

            // 2. 上传图片到 s3
            const id = await FJUtil.hashEncode(imageBlob);
            if (!id) return;
            const key = FJConfig.originalImageKey + `${id}.png`;
            const result = await FJImageStore.upLoadFileToS3Async(imageBlob, key);

            if (!result) {
                // 上传失败
                FJMessageStore.addMessage(FJLocalStore._('image-extender-upload-failed'), 'error');
                return;
            }

            const left = Math.floor(x);
            const right = width - Math.floor(imageWidth) - left;
            const top = Math.floor(y);
            const bottom = height - Math.floor(imageHeight) - top;

            // 4. 生成图片
            const request = async () => {
                return await FJNetworkStore.imageExtender(FJS3Config.S3_SERVER_HOST + key, left, right, top, bottom);
            };

            const eventIdList = [];

            for (let i = 0; i < generateNumber; i++) {
                const eventId = await FJActionCommon.createRequestTask(request, dispatch);
                eventIdList.push(eventId);
            }
            dispatch(FJActionCommon.updateFreezeInfoAction());
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

            // 3. 轮询任务状态
            const callback = data => {
                const { type } = data;

                if (type === FJConstant.ERROR) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                        'error',
                    );
                    __errorCallback();
                }

                if (type === FJConstant.SUCCESS) {
                    let endTime = new Date().getTime();
                    const generatingDuration = FJUtil.getTimeDiff(f_startGenerateTime, endTime);

                    FJUtil.eaLog('image extender generate success', {
                        number: generateNumber,
                        ratio: curBoardRatioName,
                        'generating duration': generatingDuration,
                        'resolution:': `${width} * ${height}`,
                    });
                    FJUtil.eaLog('ai tool generate success', {
                        tool: FJUtil.getToolName(),
                        'credit&free': isFree ? 'free' : 'credit',
                    });
                }

                // 将失败的任务更改为失败状态
                if (type === FJConstant.SUCCESS && data.failTaskCount > 0) {
                    __errorCallback(data.failTaskCount);
                }
            };

            dispatch(
                FJActionCommon.pollingTaskAction(eventIdList, { callback, autoDefaultTaskStatus: !FJUtil.isMobile() }),
            );
        };
    },

    /**
     * @desc 修改生成数量
     * @param {number} newGenerateNumber
     * @returns
     */
    changeGenerateNumberAction: function (newGenerateNumber) {
        return (dispatch, getState) => {
            const { generateNumber } = getState().imageExtender;

            if (generateNumber === newGenerateNumber) return;

            const isLogin = FJUtil.isLogin();

            if (isLogin) {
                const { creditNumber, freeNumCreation } = getState().common;

                if (creditNumber < 2 * newGenerateNumber && (freeNumCreation === 0 || newGenerateNumber > 1)) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
            }

            dispatch(setSliceGenerateNumber(newGenerateNumber));
        };
    },

    initImageExtenderDataAction: function () {
        return async dispatch => {
            dispatch(this._loadImageExtenderParamsAction());
        };
    },

    /**
     * @desc 文生图带参数访问加载
     * @returns
     */
    _loadImageExtenderParamsAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                if (!window.isEditPage) {
                    const url = location.origin + location.pathname;
                    FJUtil.changeLocation(url);
                }
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;
                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadImageAction(file));
                } else if (avator) {
                    try {
                        // Url 转 blob
                        const blob = await FJFileHandleUtil.downloadImage(avator);
                        // blob 转 file
                        const file = new File([blob], 'avator', { type: blob.type });
                        dispatch(this.uploadImageAction(file));
                    } catch (error) {
                        FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    }
                }
            }
        };
    },
};

export default FJActionImageExtender;
